import React from 'react'

export const USER_CUSTOM_ATTRIBUTES = [
  'Synced calendar',
  'Added credit card',
  'Businesses count',
  'Using video calls',
]

export const BUSINESS_CUSTOM_ATTRIBUTES = [
  'Staff count',
  'Services count',
  'Appointments count',
  'Locations count',
]

class Tracker {
  constructor() {
    try {
      const storedUserDataRaw = localStorage.getItem('trackerUserData')
      if (storedUserDataRaw) {
        this.user = JSON.parse(storedUserDataRaw)
      } else {
        this.user = {}
      }
    } catch {
      this.user = {}
      alert("Please enable cookies to access this page.")
    }
  }

  setUserAttributes(attributes) {
    Object.keys(attributes).forEach(key => {
      if (key === '__typename') {
        return
      }
      this.user[key] = attributes[key]
    })
    this.trackUserAttributes()
  }
  setUserAttribute(attribute, value) {
    this.user[attribute] = value
    this.trackUserAttributes()
  }
  trackUserAttributes() {
    this.log('trackUserAttributes()', this.user)

    if (window.Autopilot) {
      window.Autopilot.associate({
        Email: this.user.email,
      })
    }

    window.localStorage.setItem('trackerUserData', JSON.stringify(this.user))
  }

  resetUser() {
    this.user = {}
    window.localStorage.removeItem('trackerUserData')
  }

  trackEvent(eventName, eventCategory, eventLabel) {
    this.log('[Tracker] trackEvent()', ...arguments)
    this.trackGoogleAnalyticsEvent(eventName, eventCategory, eventLabel)
    this.trackActiveCampaignEvent(eventName, eventCategory, eventLabel)
  }

  trackGoogleAnalyticsEvent(eventName, eventCategory, eventLabel) {
    if (! window.gtag) {
      return
    }
    window.gtag('event', eventName, {
      'event_category': eventCategory,
      'event_label': (eventLabel || null),
    });
  }

  trackActiveCampaignEvent(eventName, eventCategory, eventLabel) {
    if (! window.trackcmp) {
      return
    }
    const ACTIVE_CAMPAIGN_KEY = '82b304ec227c911d3f70a06c420abb9bca5b97e7';
    const ACTIVE_CAMPAIGN_ACTID = '609829586';
    const ACTIVE_CAMPAIGN_EVENT_URLa = 'https://trackcmp.net/event';
    const activeCampaignOptions = {
      method: 'POST',
      body: [
        `actid=${ACTIVE_CAMPAIGN_ACTID}`,
        `key=${ACTIVE_CAMPAIGN_KEY}`,
        `event=${window.encodeURIComponent(eventName)}`,
        `eventdata=${window.encodeURIComponent(eventLabel)}`,
        `visit=${window.encodeURIComponent(JSON.stringify({"email": this.user.email}))}`,
      ].join('&'),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }
    const request = window.fetch(ACTIVE_CAMPAIGN_EVENT_URLa, activeCampaignOptions)
    return request
  }

  log() {
    if (window.environment === 'development' || window.displayTrackerLogs) {
      console.log(...arguments);
    }
  }
}

export const globalTracker = new Tracker()

export function withTracker(Component) {
  return class ComponentWithTracker extends React.Component {
    render() {
      return <Component tracker={globalTracker}/>
    }
  }
}

export default Tracker
